import { PersistableResource } from '../resource-base/persistableResourceTypes';

// type ConstStringArray = readonly [string, ...string[]]
// type ObjectFromList<T extends ConstStringArray, V = string> = {
//     [K in (T extends ReadonlyArray<infer U> ? U : never)]: V
// };
//
// const testArr = ['aa', 'bb', 'cc'] as const;
//
// function createConstAndSchema<T extends ConstStringArray>(arr: T) {
//     let temp = {}
//     arr.forEach(it => temp = {...temp,  it})
//
//     return {
//         constant: temp as ObjectFromList<T>,
//         schema: z.enum(arr)
//     }
// }
//
// export const { constant, schema } = createConstAndSchema(testArr)

type StringIndexedObject = Record<string, any>;

export const copyOverExistingProperties = <R1 extends PersistableResource, R2 extends PersistableResource>(
    newResource: R1,
    previousResource: R2 | undefined
): R1 => {
    if (!previousResource) {
        return newResource;
    }

    const copyResource: StringIndexedObject = { ...newResource };

    Object.keys(copyResource).forEach(key => {
        if (Object.hasOwn(previousResource, key)) {
            if (typeof copyResource[key] === typeof (previousResource as StringIndexedObject)[key]) {
                copyResource[key] = (previousResource as StringIndexedObject)[key];
            }
        }
    });

    return copyResource as R1;
};
